import i18n from '@/i18n'

import {
  ABSENCE_UNEXCUSED_STATUSES,
  type ClassUnexcusedAbsenceStatus
} from '../constants/absences-statuses'

export const getAbsenceStatusOptions = (): {
  label: string
  value: ClassUnexcusedAbsenceStatus
}[] =>
  ABSENCE_UNEXCUSED_STATUSES.map(status => ({
    value: status,
    label: i18n.t(`statuses.${status}`, { ns: 'classes' })
  }))
